import styled from "styled-components";

export const SectionContainer = styled.div`
    padding: 15px 25px;
`